import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';
import { routes } from './app.routes';
import {provideHttpClient} from '@angular/common/http';
import {provideTranslate} from './providers/translate.provider';
import {MarkdownModule} from 'ngx-markdown';
import {provideNzIcons} from 'ng-zorro-antd/icon';
import {
  AlertOutline,
  BankOutline,
  BugOutline,
  BulbOutline,
  CloudOutline,
  ContactsOutline,
  DeleteOutline,
  DownloadOutline,
  EditOutline,
  EnvironmentOutline,
  ExperimentOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileExcelOutline,
  FilePdfOutline,
  FireOutline,
  FolderOpenOutline,
  GatewayOutline,
  GlobalOutline,
  HomeOutline,
  InboxOutline,
  MailOutline,
  MedicineBoxOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MoonOutline,
  NumberOutline,
  PhoneOutline,
  PlusOutline,
  QrcodeOutline,
  RocketOutline,
  SafetyOutline,
  SaveOutline,
  SettingOutline,
  ThunderboltOutline,
  ToolOutline,
  UpCircleOutline,
  UserOutline,
  VideoCameraOutline,
  WarningFill,
  LikeOutline,
  DislikeOutline,
  MessageOutline,
  LinkOutline,
  SafetyCertificateOutline,
  ExportOutline,
  KeyOutline,
  BuildOutline,
  MobileOutline,
  InsuranceOutline,
  SyncOutline,
  ContainerOutline,
  DeploymentUnitOutline,
  FileTextOutline,
  AppstoreOutline,
  MenuOutline,
  LockOutline,
  WifiOutline,
  LoginOutline,
  LogoutOutline,
  SolutionOutline,
  StarOutline,
  RobotOutline,
  ReloadOutline,
  DatabaseOutline,
  BellOutline,
  TeamOutline,
  ArrowLeftOutline,
  BookOutline,
  CommentOutline,
  FilterOutline,
  InfoOutline,
  FileProtectOutline,
  PoweroffOutline,
  WarningOutline,
  CarOutline,
  CustomerServiceOutline,
  NotificationOutline,
  UnlockOutline,
  ShopOutline,
  PushpinOutline,
  CameraOutline,
  SecurityScanOutline,
  CompassOutline,
  FileImageOutline,
  QuestionCircleOutline,
  CalendarOutline,
  ClockCircleOutline,
  CopyOutline,
  CloseOutline,
  DownOutline,
  RightOutline,
  UpOutline,
  FileOutline,
  FilePptOutline,
  FileWordOutline,
  HeartOutline
} from '@ant-design/icons-angular/icons';
import {de_DE, provideNzI18n} from 'ng-zorro-antd/i18n';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import { provideClientHydration } from '@angular/platform-browser';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideClientHydration(),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'top' })),
    importProvidersFrom(MarkdownModule.forRoot()),
    provideNzI18n(de_DE),
    provideAnimationsAsync(),
    provideHttpClient(),
    provideTranslate(),
    provideNzIcons([
      AlertOutline,
      BankOutline,
      BugOutline,
      BulbOutline,
      CloudOutline,
      ContactsOutline,
      DeleteOutline,
      DownloadOutline,
      EditOutline,
      EnvironmentOutline,
      ExperimentOutline,
      EyeInvisibleOutline,
      EyeOutline,
      FileExcelOutline,
      FilePdfOutline,
      FireOutline,
      FolderOpenOutline,
      GatewayOutline,
      GlobalOutline,
      HomeOutline,
      InboxOutline,
      MailOutline,
      MedicineBoxOutline,
      MenuFoldOutline,
      MenuUnfoldOutline,
      MoonOutline,
      NumberOutline,
      PhoneOutline,
      PlusOutline,
      QrcodeOutline,
      RocketOutline,
      SafetyOutline,
      SaveOutline,
      SettingOutline,
      ThunderboltOutline,
      ToolOutline,
      UpCircleOutline,
      UserOutline,
      VideoCameraOutline,
      WarningFill,
      LikeOutline,
      DislikeOutline,
      MessageOutline,
      LinkOutline,
      SafetyCertificateOutline,
      ExportOutline,
      KeyOutline,
      BuildOutline,
      MobileOutline,
      InsuranceOutline,
      SyncOutline,
      ContainerOutline,
      DeploymentUnitOutline,
      FileTextOutline,
      AppstoreOutline,
      MenuOutline,
      LockOutline,
      WifiOutline,
      LoginOutline,
      LogoutOutline,
      SolutionOutline,
      StarOutline,
      RobotOutline,
      ReloadOutline,
      DatabaseOutline,
      BellOutline,
      TeamOutline,
      ArrowLeftOutline,
      BookOutline,
      CommentOutline,
      FilterOutline,
      InfoOutline,
      FileProtectOutline,
      PoweroffOutline,
      WarningOutline,
      CarOutline,
      CustomerServiceOutline,
      NotificationOutline,
      UnlockOutline,
      ShopOutline,
      PushpinOutline,
      CameraOutline,
      SecurityScanOutline,
      CompassOutline,
      FileImageOutline,
      QuestionCircleOutline,
      CalendarOutline,
      ClockCircleOutline,
      CopyOutline,
      CloseOutline,
      DownOutline,
      RightOutline,
      UpOutline,
      FileOutline,
      FilePptOutline,
      FileWordOutline,
      HeartOutline
    ]),
]};
